import React, { Component } from 'react';
import { Dayjs } from 'dayjs';
import Presenter from './presenter';
import createStateModel, { StateModel } from './model';
import View from './view';

export interface IndexProps {
  minAge: number;
  format: string;
  onComplete: (date: Dayjs | null) => void;
  onError: () => void;
}

class AgeLanding extends Component<IndexProps> {
  presenter: Presenter;

  constructor(props: IndexProps) {
    super(props);
    const { minAge, onComplete, onError } = props;
    const model = createStateModel(this);
    this.presenter = new Presenter(model, minAge, onComplete, onError);
  }

  render(): JSX.Element {
    const { format } = this.props;

    return <View {...(this.state as StateModel)} presenter={this.presenter} format={format} />;
  }
}

export default AgeLanding;
